var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sorter"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('fieldset', [_c('legend', [_vm._v("Banglore CBS (BLR/FC1 - 270)")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button', {
        active: _vm.currentTab === tab.key
      }],
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key
        }
      }
    }, [_vm._v("\n              " + _vm._s(tab.value) + "\n            ")])
  }), 0)])]), _vm._v(" "), _c('keep-alive', [_c(_vm.currentTabComponent, {
    key: _vm.componentKey,
    tag: "component",
    staticClass: "tab"
  })], 1)], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42336fcb","hasScoped":true}!./src/views/components/bangloreCBS/bangloreCBS.html
// module id = 1446
// module chunks = 2